import React, { useState } from 'react';
import { Box, Text, RadioButtonGroup } from 'grommet';
import { Calendar } from 'grommet-icons';
import { IoBaseballOutline } from 'react-icons/io5';
import { analytics } from '../../../services/analytics';
import { TimePeriod, Hit } from '../hitScope.types';
import {
  HitScopeFiltersProps,
  ClipQuery,
  DAY,
  TEAM_TIME_OPTIONS,
  TEAM_HIT_OPTIONS,
  PLAYER_HIT_OPTIONS,
  PLAYER_TIME_OPTIONS,
} from '../hitScope.types';

const HitScopeFilters: React.FC<HitScopeFiltersProps> = ({
  setEndAtTs,
  setHitType,
  loading,
  track,
}) => {
  const [selectedQuery, setSelectedQuery] = useState<ClipQuery>({
    time: TimePeriod.ALL_TIME,
    type: Hit.HITS,
  });

  let hitOptions = PLAYER_HIT_OPTIONS;
  let timeOptions = PLAYER_TIME_OPTIONS;
  if (track.type === 'team') {
    hitOptions = TEAM_HIT_OPTIONS;
    timeOptions = TEAM_TIME_OPTIONS;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const changePeriod = (event: any) => {
    const period = event.target.value;
    if (period === TimePeriod.LAST_7) {
      setEndAtTs(new Date().getTime() / 1000 - 7 * DAY);
    } else if (period === TimePeriod.LAST_MONTH) {
      setEndAtTs(new Date().getTime() / 1000 - 31 * DAY);
    } else if (period === TimePeriod.ALL_TIME) {
      setEndAtTs(0);
    }
    analytics.track('HitScope Time Period Clicked', {
      ...track,
    });
    setSelectedQuery({
      ...selectedQuery,
      time: event.target.value as TimePeriod,
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const changeHitType = (event: any) => {
    analytics.track('HitScope Quick Outcome Clicked', {
      ...track,
    });
    setSelectedQuery({
      ...selectedQuery,
      type: event.target.value as Hit,
    });
    setHitType(event.target.value as Hit);
  };
  return (
    <Box>
      <Box align="center" direction="row" gap="small">
        <Calendar />
        <RadioButtonGroup
          disabled={loading}
          name="radio"
          direction="row"
          gap="xsmall"
          options={timeOptions}
          value={selectedQuery.time}
          onChange={changePeriod}
        >
          {(
            option: string,
            { checked, focus }: { checked: boolean; focus: boolean }
          ) => {
            let background;
            if (checked) {
              background = 'brand';
            } else if (focus) {
              background = 'primary-1';
            } else {
              background = 'light-2';
            }
            return (
              <Box margin="xsmall" pad="small" background={background} round>
                <Text
                  margin={{ left: 'small', right: 'small' }}
                  size="small"
                  weight={checked ? 'bold' : 'normal'}
                >
                  {option}
                </Text>
              </Box>
            );
          }}
        </RadioButtonGroup>
      </Box>
      <Box align="center" direction="row" gap="small">
        <IoBaseballOutline style={{ height: '24px', width: '24px' }} />
        <RadioButtonGroup
          disabled={loading}
          name="radio"
          direction="row"
          gap="xsmall"
          options={hitOptions}
          value={selectedQuery.type}
          onChange={changeHitType}
        >
          {(
            option: string,
            { checked, focus }: { checked: boolean; focus: boolean }
          ) => {
            let background;
            if (checked) {
              background = 'tertiary-1';
            } else if (focus) {
              background = 'primary-1';
            } else {
              background = 'light-2';
            }
            return (
              <Box margin="small" pad="small" background={background} round>
                <Text
                  margin={{ left: 'small', right: 'small' }}
                  size="small"
                  weight={checked ? 'bold' : 'normal'}
                >
                  {option}
                </Text>
              </Box>
            );
          }}
        </RadioButtonGroup>
      </Box>
    </Box>
  );
};

export default HitScopeFilters;
